import { IApplicationState } from '../../types/redux';

// TODO: Удалить в CD-206634
/* istanbul ignore next */
export const selectIsRedesign = (state: IApplicationState): boolean => {
  return state.isRedesign;
};
